export default (theme) => ({
  tabletStepperForm: {
    marginTop: theme.custom.marginTop,
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    margin: '30px 0',
    padding: 20,
    boxSizing: 'border-box',
    width: 'auto',
    borderRadius: 33,
    overflow: 'hidden',
    backgroundColor: '#ffffff',
    [theme.breakpoints.down('md')]: {
      marginTop: 0,
    },
  },
  tabletStepperHeader: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 120,
      fontSize: 28,
      [theme.breakpoints.down('md')]: {
        marginTop: 90,
        fontSize: 16,
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: 84,
        fontSize: 14,
      },
    },
  },
  step: {
    width: 27,
    height: 27,
    color: theme.palette.disabled.main,
    marginRight: 10,
    fontSize: 30,
  },
  label: {
    '& span': {
      color: 'black',
      fontSize: 18,
    },
    '& .MuiStepLabel-active': {
      fontWeight: 700,
    },
  },
});
